'use strict'

import './ums-sub-header.styles.scss'

export const umsSubHeader = {
  transclude: true,
  template: `
    <div class="md-body-2" md-colors="{color: 'default-background-700'}" ng-transclude></div>
  `,
}



// WEBPACK FOOTER //
// ./app/shared/components/sub-header/ums-sub-header.component.js